import { DefaultTheme } from 'styled-components';

const theme: DefaultTheme = {
    colors: {
        text: {
            black: 'rgba(0,0,0,0.87)',
            gray: '#5C5C5C'
        },
        darkGray: '#E0E0E0',
        lightGray: '#E5E5E5'
    }
};

export default theme;
